import React from 'react';
import { createRoot } from 'react-dom/client';

import shouldPolyfill from './polyfills/should';

function getAppProps() {
    return window.props || {};
}

function renderApp(Container, props) {
    const element = document.getElementById('app');
    const container = React.createElement(Container, props);
    const strictMode = React.createElement(React.StrictMode, {}, container);
    const root = createRoot(element);
    root.render(strictMode);
}

function loadContainer({ isPanneau = false }) {
    return isPanneau
        ? import('./components/Panneau').then(({ default: Container }) => Container)
        : import('./components/App').then(({ default: Container }) => Container);
}

const props = getAppProps();

// The consent modal opens right away for visitors who haven't answered yet: fetch it with the app
if (!props.isPanneau && !props.hasConsented) {
    import('./components/modals/ConsentModal');
}

if (shouldPolyfill()) {
    import('./polyfills/index')
        .then(() => loadContainer(props))
        .then((Container) => renderApp(Container, props));
} else {
    loadContainer(props).then((Container) => renderApp(Container, props));
}
